/**
 * Runtime state for the currently-active eKYC flow.
 *
 * Set when the eKYC type is resolved (see onfido-information) and read by
 * page-directory to gate the US Veriff wallet result screens — kept in this
 * dependency-free leaf module so page-directory doesn't need to import a provider
 * (which would introduce a circular dependency via RouteProvider).
 *
 * `isWalletOnboarding` distinguishes the wallet-onboarding flow from other US
 * Veriff entry points (send-money higher-limit, settings document upload), which
 * must NOT get the wallet-specific copy. Reset on logout (see AuthProvider.logout).
 */
export const EkycFlowState: { currentType: string | null; isWalletOnboarding: boolean } = {
  currentType: null,
  isWalletOnboarding: false,
};

export function resetEkycFlowState() {
  EkycFlowState.currentType = null;
  EkycFlowState.isWalletOnboarding = false;
}



// WEBPACK FOOTER //
// ./src/providers/myria/ekyc-flow-state.ts